export const FETCH_ORDERS = 'user/FETCH_ORDERS'
